import { useState } from "react"
import { Route, Switch } from "react-router-dom/cjs/react-router-dom.min"
import { ResetPassword } from "../components/authentication/ResetPassword"
import { ForgotPassword } from "../components/authentication/ForgotPassword"
import { SignUp } from "../components/authentication/SignUp"
import { SignIn } from "../components/authentication/SignIn"
import { SharedContent } from "../components/SharedContent"
import { AuthLandingPage } from "../components/authentication/AuthLandingPage"
import LoggedOutSharePage from "../components/share/LoggedOutShareBG"
import { WeekReflectionContextProvider } from "../components/weekReflection/WeekReflectionContext"

export const RoutesForSignedOutUser = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    return (
        <Switch>
            <Route path="/shared">
                <LoggedOutSharePage>
                    <WeekReflectionContextProvider>
                        <SharedContent />
                    </WeekReflectionContextProvider>
                </LoggedOutSharePage>
            </Route>
            <Route path="/reset-password">
                <AuthLandingPage>
                    <ResetPassword />
                </AuthLandingPage>
            </Route>
            <Route path="/forgot-password">
                <AuthLandingPage>
                    <ForgotPassword />
                </AuthLandingPage>
            </Route>
            <Route path="/signup">
                <AuthLandingPage>
                    <SignUp
                        password={password}
                        setPassword={setPassword}
                        email={email}
                        setEmail={setEmail}
                    />
                </AuthLandingPage>
            </Route>
            <Route>
                <AuthLandingPage>
                    <SignIn
                        password={password}
                        setPassword={setPassword}
                        email={email}
                        setEmail={setEmail}
                    />
                </AuthLandingPage>
            </Route>
        </Switch>
    )
}